import React from 'react';
import PropTypes from 'prop-types';

/** renders instructions text */
const Instructions = ({ children }) => <div className="instructions">{children}</div>;

Instructions.propTypes = {
  children: PropTypes.node
};

export default Instructions;
